import { NavLink, useLocation } from "react-router-dom";
import SideBarLink from "./SideBarLink";
import {
  AccountingSvg,
  AdminSettingsSvg,
  BillsSvg,
  BTTeamStatusSvg,
  ChevronDown,
  Contractsvg,
  CurrentTeamStatusSvg,
  Dashboardsvg,
  EmployeeStatsSvg,
  FinanceSvg,
  FinecialSvg,
  HourlySvg,
  InvoicesSvg,
  LeaveManagement,
  Manageapplication,
  Manageroletab,
  ManagerStatsSvg,
  NoteSvg,
  NotificationSvg,
  PaymentReportSvg,
  PrintSvg,
  ProjectsSvg,
  ReportReciptSvg,
  ReportsSvg,
  ReportTaxReport,
  StatsSvg,
  SuportSvg,
  TeamAllocationSvg,
  TimingsReportSvg,
  Vendororder,
  WarningSvg,
} from "../SvgFile/Index";
import { useEffect, useRef, useState } from "react";
import Logout from "../Component/Pages/Auth/Logout";

export default function Sidebar() {
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState("");
  const [links, setLinks] = useState([]);
  const user = JSON.parse(localStorage.getItem("userData"));
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState("");

  const handleClose = () => {
    setOpen(false);
  };

  const member_links = [
    {
      url: "/projects",
      roleName: "Manage Projects",
      icon: <Vendororder />,
    },
    {
      url: "/early-warnings",
      roleName: "AI Warnings",
      icon: <WarningSvg />,
    },
    {
      url: "/task",
      roleName: "Manage Tasks",
      icon: <PrintSvg />,
    },
    {
      url: "/employee-stats",
      roleName: "My Stats",
      icon: <ManagerStatsSvg />,
    },
    {
      url: "/leave-requests",
      roleName: "My Leaves",
      icon: <LeaveManagement />,
    },
    {
      url: "/activitylog",
      roleName: "Activity Logs",
      icon: <ReportTaxReport />,
    },
    {
      url: "/my-document",
      roleName: "Documents",
      icon: <PrintSvg />,
    },
    {
      url: "/notification",
      roleName: "Notifications",
      icon: <NotificationSvg />,
    },

    {
      url: "/note",
      roleName: "My Notes",
      icon: <NoteSvg />,
    },
    {
      url: "/support",
      roleName: "Hardware Support",
      icon: <SuportSvg />,
    },
  ];

  const manager_links = [
    {
      url: "/projects",
      roleName: "Manage Projects",
      icon: <Vendororder />,
    },
    {
      url: "/early-warnings",
      roleName: "AI Warnings",
      icon: <WarningSvg />,
    },
    {
      url: "/task",
      roleName: "Manage Tasks",
      icon: <PrintSvg />,
    },
    {
      url: "/employee-stats",
      roleName: "My Stats",
      icon: <ManagerStatsSvg />,
    },
    {
      url: "/leave-requests",
      roleName: "My Leaves",
      icon: <LeaveManagement />,
    },
    // {
    //   url: "/estimation",
    //   roleName: "Manage Estimations",
    //   icon: <ReportOrderReport />,
    // },
    {
      url: "/activitylog",
      roleName: "Activity Logs",
      icon: <ReportTaxReport />,
    },
    {
      url: "/my-document",
      roleName: "Documents",
      icon: <PrintSvg />,
    },
    {
      url: "/notification",
      roleName: "Notifications",
      icon: <NotificationSvg />,
    },

    {
      url: "/note",
      roleName: "My Notes",
      icon: <NoteSvg />,
    },
    {
      url: "/support",
      roleName: "Hardware Support",
      icon: <SuportSvg />,
    },
  ];

  const adminmanager_links = [
    {
      roleName: "Projects",
      icon: <ProjectsSvg />,
      children: [
        {
          url: "/projects",
          roleName: "Manage Projects",
          icon: <Vendororder />,
        },
        {
          url: "/stats",
          roleName: "Projects P/L Stats",
          icon: <StatsSvg />,
        },
      ],
    },
    {
      url: "/early-warnings",
      roleName: "AI Warnings",
      icon: <WarningSvg />,
    },

    {
      roleName: "Team's Status",
      icon: <BTTeamStatusSvg />,
      children: [
        {
          url: "/task",
          roleName: "Manage Tasks",
          icon: <PrintSvg />,
        },

        {
          url: "/activitylog",
          roleName: "Activity Logs",
          icon: <ReportTaxReport />,
        },
        {
          url: "/count",
          roleName: "Current Team's Status",
          icon: <CurrentTeamStatusSvg />,
        },

        {
          url: "/leave-requests",
          roleName: "Leave Requests",
          icon: <LeaveManagement />,
        },
      ],
    },

    {
      roleName: "Reports",
      icon: <ReportsSvg />,
      children: [
        {
          url: "/hourly-report",
          roleName: "Hourly Report",
          icon: <HourlySvg />,
        },
        {
          url: "/timings-report",
          roleName: "Timings Report",
          icon: <TimingsReportSvg />,
        },

        {
          url: "/manager-stats",
          roleName: "My Stats",
          icon: <ManagerStatsSvg />,
        },
        {
          url: "/employee-stats",
          roleName: "Employee Stats",
          icon: <EmployeeStatsSvg />,
        },
        {
          url: "/team-allocation",
          roleName: "Team Allocation",
          icon: <TeamAllocationSvg />,
        },

        // {
        //   url: "/pl-report",
        //   roleName: "Employee P/L Report",
        //   icon: <EmployeePlSvg />,
        // },
      ],
    },

    {
      roleName: "BT Finance",
      icon: <FinanceSvg />,
      children: [
        {
          url: "/payment-report",
          roleName: "Payments Received",
          icon: <PaymentReportSvg />,
        },
      ],
    },

    {
      url: "/client",
      roleName: "Manage Clients",
      icon: <ReportReciptSvg />,
    },
    {
      url: "/my-document",
      roleName: "Documents",
      icon: <PrintSvg />,
    },
    {
      url: "/note",
      roleName: "My Notes",
      icon: <NoteSvg />,
    },
    // {
    //   url: "/estimation",
    //   roleName: "Manage Estimations",
    //   icon: <ReportOrderReport />,
    // },

    {
      url: "/notification",
      roleName: "Notifications",
      icon: <NotificationSvg />,
    },

    {
      url: "/support",
      roleName: "Hardware Support",
      icon: <SuportSvg />,
    },
  ];

  const admin_links = [
    {
      roleName: "BT Team's Status",
      icon: <BTTeamStatusSvg />,
      children: [
        {
          url: "/count",
          roleName: "Current Team's Status",
          icon: <CurrentTeamStatusSvg />,
        },
        {
          url: "/task",
          roleName: "Team Task Management",
          icon: <PrintSvg />,
        },
        {
          url: "/activitylog",
          roleName: "Emp Activity Logs",
          icon: <ReportTaxReport />,
        },
      ],
    },

    {
      roleName: "Projects",
      icon: <ProjectsSvg />,
      children: [
        {
          url: "/projects",
          roleName: "Manage Projects",
          icon: <Vendororder />,
        },
        {
          url: "/stats",
          roleName: "Projects P/L Stats",
          icon: <StatsSvg />,
        },
      ],
    },

    {
      roleName: "Reports",
      icon: <ReportsSvg />,
      children: [
        {
          url: "/hourly-report",
          roleName: "Hourly Report",
          icon: <HourlySvg />,
        },
        {
          url: "/timings-report",
          roleName: "Timings Report",
          icon: <TimingsReportSvg />,
        },

        // {
        //   url: "/attendance",
        //   roleName: "Attendance Report",
        //   icon: <TimingsReportSvg />,
        // },

        {
          url: "/manager-stats",
          roleName: "Manager Stats",
          icon: <ManagerStatsSvg />,
        },
        {
          url: "/employee-stats",
          roleName: "Employee Stats",
          icon: <EmployeeStatsSvg />,
        },
        {
          url: "/team-allocation",
          roleName: "Team Allocation",
          icon: <TeamAllocationSvg />,
        },

        // {
        //   url: "/pl-report",
        //   roleName: "Employee P/L Report",
        //   icon: <EmployeePlSvg />,
        // },
      ],
    },

    {
      roleName: "BT Finance",
      icon: <FinanceSvg />,
      children: [
        {
          url: "/payment-report",
          roleName: "Payments Received",
          icon: <PaymentReportSvg />,
        },

        {
          url: "/financial-data",
          roleName: "Financial Data",
          icon: <FinecialSvg />,
        },

        {
          url: "/invoices",
          roleName: "Invoices",
          icon: <InvoicesSvg />,
        },
        {
          url: "/billing",
          roleName: "Bills",
          icon: <BillsSvg />,
        },
        {
          url: "/accounting",
          roleName: "Accounting",
          icon: <AccountingSvg />,
        },
      ],
    },

    // 🔥 NEW SUB MENU
    {
      roleName: "Manage Company",
      icon: <AdminSettingsSvg />,
      children: [
        {
          url: "/empolyee",
          roleName: "Manage Employees",
          icon: <Contractsvg />,
        },
        {
          url: "/client",
          roleName: "Manage Clients",
          icon: <ReportReciptSvg />,
        },
        {
          url: "/department",
          roleName: "Manage Departments",
          icon: <Manageapplication />,
        },
        {
          url: "/technology",
          roleName: "Manage Technologies",
          icon: <Manageroletab />,
        },
      ],
    },
    {
      roleName: "HR Department",
      icon: <Manageapplication />,
      children: [
        {
          url: "/hr-projects",
          roleName: "HR Activities",
          icon: <Vendororder />,
        },
        {
          url: "/hr-task",
          roleName: "HR Tasks",
          icon: <PrintSvg />,
        },
        {
          url: "/hr-leave",
          roleName: "Leave Balance",
          icon: <LeaveManagement />,
        },
        {
          url: "/leave-requests",
          roleName: "Leave Requests",
          icon: <LeaveManagement />,
        },
        {
          url: "/hr-document",
          roleName: "Documents",
          icon: <PrintSvg />,
        },
      ],
    },

    // {
    //   url: "/estimation",
    //   roleName: "Manage Estimations",
    //   icon: <ReportOrderReport />,
    // },

    {
      url: "/notification",
      roleName: "Notifications",
      icon: <NotificationSvg />,
    },
    {
      url: "/note",
      roleName: "My Notes",
      icon: <NoteSvg />,
    },
  ];

  const hr_links = [
    {
      url: "/early-warnings",
      roleName: "AI Warnings",
      icon: <WarningSvg />,
    },

    {
      roleName: "Reports",
      icon: <ReportsSvg />,
      children: [
        {
          url: "/hourly-report",
          roleName: "Hourly Report",
          icon: <HourlySvg />,
        },
        {
          url: "/timings-report",
          roleName: "Timings Report",
          icon: <TimingsReportSvg />,
        },
        {
          url: "/activitylog",
          roleName: "Activity Logs",
          icon: <ReportTaxReport />,
        },
      ],
    },

    {
      roleName: "My Workspace",
      icon: <ProjectsSvg />,
      children: [
        {
          url: "/hr-projects",
          roleName: "My Activities",
          icon: <Vendororder />,
        },

        {
          url: "/hr-task",
          roleName: "My Tasks",
          icon: <PrintSvg />,
        },
        {
          url: "/note",
          roleName: "My Notes",
          icon: <NoteSvg />,
        },
      ],
    },

    {
      roleName: "Emp Management",
      icon: <Manageapplication />,
      children: [
        {
          url: "/empolyee-details",
          roleName: "Employee Details",
          icon: <Contractsvg />,
        },
        {
          url: "/hr-leave",
          roleName: "Leaves",
          icon: <LeaveManagement />,
        },

        {
          url: "/leave-requests",
          roleName: "Leave Requests",
          icon: <LeaveManagement />,
        },
        
        {
          url: "/hr-document",
          roleName: "Documents",
          icon: <PrintSvg />,
        },
      ],
    },

    {
      url: "/billing",
      roleName: "Bills",
      icon: <BillsSvg />,
    },

    {
      url: "/notification",
      roleName: "Notifications",
      icon: <NotificationSvg />,
    },
    {
      url: "/support",
      roleName: "Hardware Support",
      icon: <SuportSvg />,
    },
  ];

  useEffect(() => {
    if (user?.role === "Super Admin") {
      setLinks(admin_links);
    } else if (user?.role === "Manager") {
      setLinks(manager_links);
    } else if (user?.role === "Admin (Manager)") {
      setLinks(adminmanager_links);
    } else if (user?.role === "HR") {
      setLinks(hr_links);
    } else {
      setLinks(member_links);
    }
    // eslint-disable-next-line
  }, []);

  const handleClosemenu = () => {
    setShow("");
  };

  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShow(""); // Hide the menu
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const activeParent = links.find(
      (item) =>
        item.children &&
        item.children.some((child) => location.pathname.startsWith(child.url)),
    );

    if (activeParent) {
      setOpenMenu(activeParent.roleName);
    } else {
      setOpenMenu("");
    }
  }, [location.pathname, links]);

  return (
    <>
      <div className="intersight_menu" ref={menuRef}>
        <div className="top_menu">
          {/*Start Logo Dropdown*/}
          <div className="brand">
            <button
              className="navbar-toggler navbar-toggle"
              type="button"
              onClick={() => setShow((prev) => (prev === "show" ? "" : "show"))}
            >
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <div className="dropdown">
              <button
                className="border-0 w-100 d-flex align-items-center sidebar-brand-btn"
                type="button"
              >
                <span
                  className="d-flex align-items-center justify-content-center sidebar-brand-logo"
                  style={{ overflow: "hidden" }}
                >
                  <img src="/image/BT-logo 2.png" alt="" loading="lazy" />
                </span>
                <span className="sidebar-brand-text">Brain Technosys PMS</span>
              </button>
            </div>
          </div>

          {/*End Logo Dropdown*/}
          {/*Start Menu*/}
          <div className={`intersight_home ${show}`}>
            <div className="menu_div">
              <ul>
                <li onClick={() => setShow("")}>
                  <NavLink
                    to="/dashboard"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <span>
                      <Dashboardsvg />
                    </span>
                    Dashboard
                  </NavLink>
                </li>
                {user?.role === "Super Admin" && (
                  <li onClick={() => setShow("")}>
                    <NavLink
                      to="/early-warnings"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <span>
                        <WarningSvg />
                      </span>
                      AI Warnings <span className="sidebar-badge-new">New</span>
                    </NavLink>
                  </li>
                )}

                <li className="without_label">Workspace</li>
              </ul>
              <ul className="menu_scrollbar">
                {links?.map((item, i) => {
                  const hasChildren = item.children;
                  const isOpen = openMenu === item.roleName;

                  if (hasChildren) {
                    return (
                      <li key={i} className={`submenu ${isOpen ? "open" : ""}`}>
                        <div
                          className="submenu-title"
                          onClick={() =>
                            setOpenMenu((prev) =>
                              prev === item.roleName ? "" : item.roleName,
                            )
                          }
                        >
                          <span className="submenu-left">
                            <span className="submenu-icon">{item.icon}</span>
                            <span className="submenu-text">
                              {item.roleName}
                            </span>
                          </span>

                          <span className="submenu-arrow">
                            {" "}
                            <ChevronDown />
                          </span>
                        </div>

                        <ul className="submenu-list">
                          {item.children.map((child, idx) => (
                            <SideBarLink
                              key={idx}
                              href={child.url}
                              name={child.roleName}
                              icon={child.icon}
                              handleClosemenu={handleClosemenu}
                            />
                          ))}
                        </ul>
                      </li>
                    );
                  }

                  return (
                    <SideBarLink
                      key={i}
                      href={item.url}
                      name={item.roleName}
                      icon={item.icon}
                      handleClosemenu={handleClosemenu}
                    />
                  );
                })}
              </ul>
            </div>
          </div>
          {/*End Start Menu*/}
        </div>
      </div>
      <Logout open={open} handleClose={handleClose} />
    </>
  );
}
